import React, { useState } from "react";
import { Button, Table, Tooltip, Divider, Input } from "antd";
import styles from "../styles/incomingPartsTable.module.css";
import { SyncOutlined } from "@ant-design/icons";
import { incomingPartsTableCols } from "../utils/incomingPartsTableUtils";
import ResizableTitle from "./resize";
import { PlusOutlined } from "@ant-design/icons";

export default function IncomingPartsBody(props) {
  const {
    incomingPartsListData,
    loading,
    totalRecords,
    onTableChange,
    currentPage,
    onRefresh,
    onIncomingPartClicked,
    currentPageSize,
    onPaginationChange,
    setShowModal,
    setIsEdit,
    onSearchNameChange,
    onSearchCodeChange,
    searchName,
    searchCode,
  } = props;
  const [columns, setColumns] = useState(
    incomingPartsTableCols(onIncomingPartClicked)
  );

  const handleResize =
    (index) =>
      (_, { size }) => {
        const newColumns = [...columns];
        newColumns[index] = {
          ...newColumns[index],
          width: size.width,
        };
        setColumns(newColumns);
      };
  const mergeColumns = columns.map((col, index) => ({
    ...col,
    onHeaderCell: (column) => ({
      width: column.width,
      onResize: handleResize(index),
      minWidth: column.minWidth,
    }),
  }));

  return (
    <>
      <div>
        <div style={{ marginBottom: "16px", display: "flex", justifyContent: "flex-start", gap: "16px" }}>
          <Input
            placeholder="Search by name"
            allowClear
            onChange={onSearchNameChange}
            value={searchName}
            style={{ width: 300 }}
          />
          <Input
            placeholder="Search by code"
            allowClear
            onChange={onSearchCodeChange}
            value={searchCode}
            style={{ width: 300 }}
          />
        </div>
        <div className={styles.containerHeader}>
          <div className={styles.containerHeaderCol1}>
            <span style={{ fontWeight: "bold" }}>Incoming Parts</span>{" "}
            <span className={styles.containerHeaderCol1Span}>
              ({totalRecords})
            </span>
          </div>
          <div className={styles.containerHeaderCol2}>
            <Tooltip title="Refresh">
              <Button
                icon={<SyncOutlined spin={loading} tool />}
                onClick={onRefresh}
                disabled={loading}
              />
            </Tooltip>
            <Divider type="vertical" />
            <Tooltip>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={() => {
                  setShowModal(true);
                  setIsEdit(false);
                }}
              >
              </Button>
            </Tooltip>
          </div>
        </div>
        <div className={styles.containerBody}>
          <Table
            bordered
            loading={loading}
            size="small"
            onChange={onTableChange}
            columns={mergeColumns}
            dataSource={incomingPartsListData}
            pagination={{
              pageSize: currentPageSize,
              total: totalRecords,
              current: currentPage,
              showSizeChanger: true,
              onChange: onPaginationChange,
            }}
            components={{
              header: {
                cell: ResizableTitle,
              },
            }}
            scroll={{ x: 1200, y: 500 }}
          />
        </div>
      </div>
    </>
  );
}
